import { useSSR, useTranslation } from "react-i18next";

import Swal from "sweetalert2";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Field from "../../components/Field";
import { useEffect, useState } from "react";
import { useApp } from "../../providers/app";
import Loader from "../../components/Loading";
import { convertT } from "../../defines";
import { mainApi } from "../../providers/api";
import objectPath from "object-path";
import { useNavigate } from "react-router-dom";

const Reg = ({ list }) => {
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const [grandtotal, setgrandtotal] = useState(0);
  useEffect(() => {
    let temp = 0;

    list?.map((r) => {
      temp += objectPath.get(r, "price") * objectPath.get(r, "count");
    });

    console.log("🚀 ~ list?.map ~ temp:", temp);
    setgrandtotal(temp);
    console.log("did");
  }, [list]);

  const onSubmit = async ({ company, companyno, name, phone, email }) => {
    try {
      setloading(true);
      const cart = localStorage.getItem("cart");
      const temp = cart ? JSON.parse(cart) : [];
      const result = await mainApi({
        url: `/service/order`,
        method: "POST",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
        data: {
          company: company,
          companyno: companyno,
          name: name,
          phone: phone,
          email: email,
          grandTotal: grandtotal,
          list: temp,
        },
      });
      console.log("🚀 ~ onSubmit ~ result:", result.data);
      Swal.fire({
        icon: "success",
        title: "订单成功",
        // title: "Захиалга амжилттай",
        // text: "Таны захиалга амжилттай бүртгэгдлээ. Манай менежер шалгаад холбогдох болно.",
        text: "您的订单已成功注册。我们的经理将会审核并与您联系。",
        showCancelButton: false,
        showConfirmButton: true,
        showDenyButton: false,
        confirmButtonColor: "#1A2E55",
        confirmButtonText: "关闭",
        // confirmButtonText: "Хаах",
      }).then((r) => {
        localStorage.clear();
        navigate("/order/home");
      });
      setloading(false);
    } catch (error) {
      setloading(false);
      return Swal.fire(
        `Анхааруулга`,
        error.response?.data?.message || error.toString(),
        "error"
      );
    }
  };

  const Validation = Yup.object().shape({
    company: Yup.string().required(t("order.error.company")),
    companyno: Yup.string().required(t("order.error.companyno")),
    name: Yup.string().required(t("order.error.name")),
    phone: Yup.string().required(t("order.error.phone")),
    email: Yup.string().required(t("order.error.email")),
  });

  return (
    <div className="flex bg-white rounded-md shadow-md p-5 w-full">
      <Formik
        initialValues={{
          company: "",
          companyno: "",
          name: "",
          phone: "",
          email: "",
        }}
        validationSchema={Validation}
        onSubmit={onSubmit}
      >
        {({}) => (
          <Form className="flex flex-col w-full gap-5 my-10 mt-5">
            <Field
              autoFocus={true}
              name="company"
              placeholder={t("order.company")}
              className={`uppercase p-3 px-4 w-full rounded-lg`}
              type="text"
            />
            <Field
              autoFocus={true}
              name="companyno"
              placeholder={t("order.companyno")}
              className={`uppercase p-3 px-4 w-full rounded-lg`}
              type="text"
            />
            <Field
              autoFocus={true}
              name="name"
              placeholder={t("order.user")}
              className={`uppercase p-3 px-4 w-full rounded-lg`}
              type="text"
            />
            <Field
              autoFocus={true}
              name="phone"
              placeholder={t("order.phone")}
              className={`uppercase p-3 px-4 w-full rounded-lg`}
              type="text"
            />
            <Field
              autoFocus={true}
              name="email"
              placeholder={t("order.email")}
              className={`uppercase p-3 px-4 w-full rounded-lg`}
              type="text"
            />
            {grandtotal && grandtotal > 0 && (
              <Field
                autoFocus={true}
                disabled={true}
                name="grandTotal"
                value={`${t("order.grandtotal")} : ${convertT(grandtotal)}`}
                placeholder={t("order.grandTotal")}
                className={`uppercase p-3 px-4 w-full rounded-lg`}
                type="text"
              />
            )}
            {loading ? (
              <div className="flex justify-center items-center h-16">
                <Loader width={"w-16"} />
              </div>
            ) : (
              <button className="bg-primary p-4" type="submit">
                {t("order.order")}
              </button>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Reg;
